import { render, staticRenderFns } from "./indexHelpcenter.vue?vue&type=template&id=038252da&"
import script from "./indexHelpcenter.vue?vue&type=script&lang=js&"
export * from "./indexHelpcenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports